import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChargingStationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"charging_station"}/>
}
